<template>
  <div>
    <!--https://www.hongkiat.com/blog/svg-meter-gauge-tutorial/ -->
    <div id="wrapper" style="position: relative;">
      <svg id="meter" viewBox="0 90 400 190 " style="width: 100%; height: 100%; transform: rotateX(180deg);">
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:#1fd419;stop-opacity:1" />
          <stop offset="20%" style="stop-color:#ffd925;stop-opacity:1" />
          <stop offset="33%" style="stop-color:#ffd925;stop-opacity:1" />
          <stop offset="67%" style="stop-color:#f26c22;stop-opacity:1" />
          <stop offset="80%" style="stop-color:#f26c22;stop-opacity:1" />
          <stop offset="100%" style="stop-color:#c41230;stop-opacity:1" />
        </linearGradient>
      </defs>
        <!-- Meter Outline (Grey) -->
        <circle id="outline_curves" r="150" cx="50%" cy="50%" stroke="#7e7e7e" :stroke-width="outlineStrokeWidth" stroke-dasharray="471, 943" fill="none"></circle>
        <!-- Range Zones (Gradient) -->
        <circle id="low" r="150" cx="50%" cy="50%" stroke="url(#grad1)" :stroke-width="strokeWidth" stroke-dasharray="471, 943" fill="none"></circle>        
        <!-- Outline Ends (Grey) -->
        <circle id="outline_ends" r="150" cx="50%" cy="50%" stroke="#7e7e7e" :stroke-width="outlineStrokeWidth" stroke-dasharray="2, 469" fill="none"></circle>
      </svg>
      <img id="meter_needle" src="../../assets/images/svg-meter-gauge-needle.svg" alt="" :style="needleStyle">
    </div>
  </div>
</template>

<script>
export default {
  name: 'GaugeWidget',
  props: {
    value: {
      type: Number,
      default: 50
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    outlineStrokeWidth: {
      type: Number,
      default: 65
    },
    strokeWidth: {
      type: Number,
      default: 60
    }
  },
  data() {
    return {
    };
  },
  methods: {
    needlePosition: function () {
      return this.value / (this.max - this.min);
    }
  },
  computed: {
    needleStyle: function () {
      let pos = this.needlePosition();
      let deg = 0;
      if (pos <= 0.5)
        deg = 270 + ((pos * 2) * 90);
      else
        deg = ((pos * 2) * 90) - 90;
      return 'height: 70%; left: 0; margin: auto; position: absolute; right: 0; top: 30%; transform-origin: bottom center; transform: rotate(' + deg + 'deg);';
    }
  }
}
</script>